<template>
    <div>
        <v-container v-if="loadSkeleton">
            <SkeletonLoader tipo="table-heading, card" ruta="niveles" />
        </v-container>
        <v-container v-else class="justify-center align-center">
            <v-card flat>
                <v-card-title class="text-h5 font-weight-bold">
                    <v-icon color="primary" class="mr-2" size="34">mdi-account-star-outline</v-icon>
                    Opción de nivel
                </v-card-title>
            </v-card>
            <v-card-text class="d-flex flex-row text-h6"
                :class="$vuetify.breakpoint.xsOnly ? ' justify-center align-center text-body-1' : 'justify-start align-center'">
                <div class="font-weight-bold ">
                    <!--                     Tu nivel ({{ opcionNivelAfiliado.anioOpcionNivel }}): -->
                    Tu nivel actual:
                </div>
                <div class="font-weight-bold primary--text ml-2" color="primary">
                    {{ nivelActual }}
                </div>
            </v-card-text>
            <v-card-text v-if="user.esesb" class="pa-0 ma-0">
                <v-alert outlined class="rounded-0 font-weight-regular text-body-1" dense dark color="secondary"
                    icon="mdi-alert-circle-outline" elevation="0">
                    Debido a tu estado matricular actual, no es posible realizar la opción de nivel.
                    En caso de tener previsto retomar la actividad en el próximo período, te solicitamos que te
                    comuniques con tu distrito.
                </v-alert>
                <div class="d-flex flex-column justify-center align-end">
                    <v-btn color="primary" class="pa-5 my-2" elevation="0" @click="irAContacto">
                        <v-icon class="mr-2">mdi-message-text-outline</v-icon>
                        Contactar con mi distrito
                    </v-btn>
                </div>
            </v-card-text>
            <v-card-text v-if="opcionNivelAfiliado.puedeTramitarNivel">
                <v-alert v-if="(opcionNivelAfiliado.nivelActualValidez !== 'P')" outlined
                    class="rounded-0 font-weight-regular text-body-1" dense dark color="secondary"
                    icon="mdi-information-outline" elevation="0">
                    {{ textInfoNivel }}
                </v-alert>
                <v-alert v-else outlined class="rounded-0 font-weight-regular text-body-1" dense dark color="secondary"
                    icon="mdi-information-outline" elevation="0">
                    Dado su nivel actual, no es necesaria la renovación anual. Sin embargo, si lo prefiere, puede
                    seleccionar un nivel diferente.
                </v-alert>
                <FormNivel @scrollBottom="scrollToBottom" />
            </v-card-text>
            <v-card-text v-else>
                <Alertas v-if="alertaNivel" v-bind="alertaNivel.props" @accionBtn="alertaNivel.onAccionBtn">
                </Alertas>
            </v-card-text>
            <v-card-text v-if="opcionNivelAfiliado.puedeDesestimar">
                <ValidationObserver v-slot="{ invalid }">
                    <v-row>
                        <v-col cols="12" md="12">
                            <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                                <v-checkbox :error-messages="v.errors[0]" :label="labelDesestimar" v-model="checkbox"
                                    color="primary" class="font-weight-bold pa-0"
                                    :class="$vuetify.breakpoint.xsOnly ? 'pb-12 mb-2' : ''"></v-checkbox>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12" class="justify-end custom-card-actions-ha">
                            <v-btn @click="desestimarNivel" color="primary" :disabled="invalid" class="pa-5"
                                elevation="0">
                                <v-icon class="mr-2">mdi-send-outline</v-icon>
                                Desestimar opción de nivel
                            </v-btn>
                        </v-col>
                    </v-row>
                </ValidationObserver>
            </v-card-text>
        </v-container>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';
import FormNivel from '@/components/forms/FormNivel.vue';
import Alertas from '@/components/alerts/Alertas.vue';
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue'

export default {
    name: "OpcionDeNivel",
    components: {
        FormNivel,
        Alertas,
        SkeletonLoader,
        ValidationObserver,
        ValidationProvider
    },
    created() {
        // adan 05/08/22
        //this.integracionBusqueda()
        // aca creamos un evento que queda a la espera de ser ejecutado desde el
        // buscador de afiliados del SICA
        /*         window.top.addEventListener("BusquedaAfiliadoDocker", function (evt) {
                    this.nroafi = evt.detail;
                }.bind(this), false); */
    },
    mounted() {
        window.scrollTo(0, -50)

        this.getItemsNivel()
        //this.getNivelAfiliado()
        if (this.opcionNivelAfiliado) {
            (this.opcionNivelAfiliado.puedeTramitarNivel !== 0) ? this.showForm = true : this.showForm = false
        }
        // Ocultar descripción si hay alertaNivel
        if (this.alertaNivel) {
            this.showDescAlert = false;
        }
    },
    data() {
        return {

            showForm: false,
            showExtemp: false,
            showDescAlert: true,
            descOpcionNivel: 'La opción de nivel te permite determinar el monto a percibir de jubilación en función de lo que elijas abonar mensualmente.  Se realiza anualmente, durante los meses de octubre y noviembre.   El nivel elegido tendrá vigencia para el año siguiente',
            //descripcionNivel: "La opción de nivel le permite al afiliado o afiliada determinar el monto a percibir de jubilación en función de lo que elija abonar mensualmente.   Existen dos ocasiones para hacerlo. La primera es al inicio de su vida profesional y luego, anualmente durante los meses de octubre y noviembre. El nivel elegido durante esos meses tendrá vigencia para el año calendario siguiente",

            nivelAfi: "",
            textoOpNiv: [
                { id: 1, texto: 'Tu trámite de Opción de NIVEL {nivel} para el {anio} ha sido enviado y quedará sujeto a revisión por parte de las áreas correspondientes.' },
                { id: 2, texto: 'Tu trámite de Opción de NIVEL {nivel} para el {anio} ha sido APROBADO.' },
                { id: 3, texto: 'Tu trámite de Opción de NIVEL {nivel} fue RECHAZADO. Puede desestimar la solicitud enviada.' },
                { id: 4, texto: 'Tu trámite de Opción de NIVEL {nivel} fue DESESTIMADO. Puede volver a solicitar una nueva opción de nivel.' },
                { id: 5, texto: 'Tu trámite de Opción de NIVEL {nivel} se encuentra PENDIENTE de aprobación.' },
            ],
            checkbox: false,
        }
    },
    methods: {
        ...mapActions(['refreshData']),
        // getItemsNivel NO va en este mapActions: la action vive en common, no en
        // opcionNivel. Estaba declarada en los dos y andaba de casualidad, porque el
        // spread de common pisaba al de opcionNivel. Invertir el orden de estas dos
        // lineas rompia la vista al montar con "unknown action type".
        ...mapActions('opcionNivel', ['nuevaOpcionNivel', 'desestimarOpcionNivel', 'getNivelAfiliado']),
        ...mapActions('common', ['getItemsNivel', 'getDatosDistrito']),

        desestimarNivel() {
            let desestimar = {
                nroafi: this.opcionNivelAfiliado.nroafi,
                nivelPedidoId: this.opcionNivelAfiliado.nivelPedidoId,
                nivelPedidoNro: this.opcionNivelAfiliado.nivelPedidoNro,
                nivelPedidoEmail: this.opcionNivelAfiliado.emailNivelPedido,
            }
            this.desestimarOpcionNivel(desestimar).then(() => {
            })
        },
        irAContacto() {
            this.$router.push({ path: '/MediosDeContacto' });
        },

        resetConfirmacion() {
            // Resetear el checkbox cuando haya cambios en el nivel
            this.checkbox = false;
        },
        splitParagraph(paragraph) {
            return paragraph.split('.   ').map(p => p.trim() + '.');
        },
        highlightText(text) {
            if (!text) return '';
            // Palabras/frases a resaltar
            const highlights = [
                'octubre',
                'noviembre',
                'opción de nivel',
            ];
            // Usar regex global e insensible a mayúsculas
            let result = text;
            highlights.forEach(word => {
                // Escapar posibles caracteres especiales
                const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp(`\\b${escaped}\\b`, 'gi');
                result = result.replace(regex, match => `<strong>${match}</strong>`);
            });
            return result;
        },
        scrollToBottom() {
            this.$nextTick(() => {
                window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: 'smooth'
                });
            });
        }
    },
    watch: {
        // Resetear confirmación cuando cambien las propiedades del nivel
        'opcionNivelAfiliado.nivelPedido'() {
            this.resetConfirmacion();
        },
        'opcionNivelAfiliado.estadoNivelPedido'() {
            this.resetConfirmacion();
        },
        'opcionNivelAfiliado.tienePlanJovenFuturo'() {
            this.resetConfirmacion();
        },
        'opcionNivelAfiliado.tieneRarFuturo'() {
            this.resetConfirmacion();
        }
    },
    computed: {
        ...mapGetters('opcionNivel', ['opcionNivelAfiliado', 'extemporaneo']),
        ...mapGetters('common', ['itemNivel']),
        ...mapGetters('auth', ['isAuthenticated', 'loadSkeleton', 'user']),
        ...mapGetters(['emailPrinc']),

        cumpleEdad() {
            return (this.opcionNivelAfiliado.anioOpcionNivel - this.user.fecnacim.split('-')[0]) < 35
        },

        textInfoNivel() {
            let lvl = this.opcionNivelAfiliado.nivelActual
            let aporteReducido = this.opcionNivelAfiliado.tieneRar || this.opcionNivelAfiliado.tienePlanJoven
            if (lvl == 2 && aporteReducido && (this.opcionNivelAfiliado.estadoRar == 'A' || this.opcionNivelAfiliado.estadoPlanJoven == 'A')) {
                if (this.opcionNivelAfiliado.tienePlanJovenFuturo || this.opcionNivelAfiliado.tieneRarFuturo) {
                    return `El ${this.tipoAporteReducido} no requiere ser renovado.`
                }
                else {
                    return `Este año finaliza tu ${this.tipoAporteReducido}. Pasarás automáticamente al NIVEL 2, salvo que elijas otro nivel.`
                }
            }
            else if (lvl >= 2) {
                return "Niveles 2, 3, 4 y 5 no requieren ser renovados."
            }
            else if (lvl == 1) {
                return 'El Nivel 1 debe renovarse anualmente, presentando recibo de sueldo y certificado de trabajo.'
            }
        },
        nivelActual() {
            const { nivelActual, tienePlanJoven, estadoPlanJoven, tieneRar, estadoRar } = this.opcionNivelAfiliado;

            // Nivel 2 con aportes reducidos
            if (nivelActual === 2) {
                if (tienePlanJoven && estadoPlanJoven === 'A') {
                    return 'PLAN MÓDULO JOVEN';
                }
                if (tieneRar && estadoRar === 'A') {
                    return 'RÉGIMEN DE APORTACIÓN REDUCIDA';
                }
                return 'NIVEL 2';
            }

            // Otros niveles
            const nivelesMap = {
                1: 'NIVEL 1',
                3: 'NIVEL 3',
                4: 'NIVEL 4',
                5: 'NIVEL 5'
            };

            return nivelesMap[nivelActual] || 'NIVEL 2';
        },
        nivelReducido() {
            if (this.opcionNivelAfiliado.tieneRar || this.opcionNivelAfiliado.tienePlanJoven) {
                return true
            } else {
                return false
            }
        },
        tipoAporteReducido() {
            if (this.opcionNivelAfiliado.estadoPlanJoven == 'A') {
                return 'NIVEL 2 (PLAN MÓDULO JOVEN)'
            } else if (this.opcionNivelAfiliado.estadoRar == 'A') {
                return 'NIVEL 2 (RÉGIMEN DE APORTACIÓN REDUCIDA)'
            }
            else {
                return '2'
            }
        },

        tipoAporteReducidoFuturo() {
            if (this.opcionNivelAfiliado.tienePlanJovenFuturo) {
                return 'PLAN MÓDULO JOVEN'
            } else if (this.opcionNivelAfiliado.tieneRarFuturo) {
                return 'RÉGIMEN DE APORTACIÓN REDUCIDA'
            } else {
                return 'NIVEL 2'
            }
        },

        labelDesestimar() {
            if (this.opcionNivelAfiliado.nivelPedido == 2 && this.opcionNivelAfiliado.estadoNivelPedido === 'A') {
                // Si altaPJ es 1, mostrar "nivel (reducido)"
                if (this.opcionNivelAfiliado.altaPJ == 1) {
                    return `Confirmo que quiero desestimar mi solicitud de NIVEL ${this.opcionNivelAfiliado.nivelPedido} (${this.tipoAporteReducidoFuturo}).`;
                } else {
                    return `Confirmo que quiero desestimar mi solicitud de NIVEL ${this.opcionNivelAfiliado.nivelPedido}.`;
                }
            } else {
                return `Confirmo que quiero desestimar mi solicitud de NIVEL ${this.opcionNivelAfiliado.nivelPedido}.`;
            }
        },

        botonDesestimar() {
            if (this.opcionNivelAfiliado.nivelPedido == 2) {
                // Si altaPJ es 1, mostrar "nivel (reducido)"
                if (this.opcionNivelAfiliado.altaPJ == 1) {
                    return 'NIVEL';
                } else {
                    return this.tipoAporteReducidoFuturo;
                }
            } else {
                return `nivel ${this.opcionNivelAfiliado.nivelPedido}`;
            }
        },
        alertaNivel() {
            // Si hay desestimación pendiente
            if (this.opcionNivelAfiliado.desestimacionPendiente) {
                return {
                    props: {
                        message: this.textoOpNiv[4].texto
                    }
                }
            }
            // Si está pendiente o en trámite
            if (['X', 'P'].includes(this.opcionNivelAfiliado.estadoNivelPedido)) {
                let nivelDisplay = this.opcionNivelAfiliado.nivelPedido;
                // Si es nivel 2 y altaPJ es 1, mostrar "nivel (reducido)"
                if (this.opcionNivelAfiliado.nivelPedido == 2 && this.opcionNivelAfiliado.altaPJ == 1) {
                    nivelDisplay = 'nivel (reducido)';
                }

                return {
                    props: {
                        message: this.textoOpNiv[0].texto,
                        entramite: nivelDisplay,
                        puededesestimar: true,
                        accion: "Desestimar nivel",
                        icon: "mdi-information-outline"
                    },
                    onAccionBtn: this.desestimar
                }
            }
            // Si está aprobado
            if (this.opcionNivelAfiliado.estadoNivelPedido === 'A') {
                let nivelDisplay = this.opcionNivelAfiliado.nivelPedido;
                // Si es nivel 2 aprobado, determinar qué mostrar
                if (this.opcionNivelAfiliado.nivelPedido == 2) {
                    // Si altaPJ es 1, mostrar "nivel (reducido)"
                    if (this.opcionNivelAfiliado.altaPJ == 1) {
                        nivelDisplay = this.tipoAporteReducido;
                    } else {
                        nivelDisplay = this.opcionNivelAfiliado.nivelPedido;
                    }
                }

                return {
                    props: {
                        message: this.textoOpNiv[1].texto,
                        accion: "Desestimar nivel",
                        puededesestimar: this.opcionNivelAfiliado.puedeDesestimar,
                        entramite: nivelDisplay
                    },
                    onAccionBtn: this.desestimar
                }
            }
            // Si está rechazado
            if (this.opcionNivelAfiliado.estadoNivelPedido === 'R') {
                return {
                    props: {
                        message: this.textoOpNiv[3].texto
                    }
                }
            }
            // Si no hay nada para mostrar
            return null;
        },
    }
}

</script>

<style>
/* Posicionar el botón de cierre del alert en la esquina superior derecha */
.alert-relative {
    position: relative;
}

.alert-close {
    position: absolute;
    top: 6px;
    right: 6px;
}

.custom-card-actions-ha {
    position: fixed;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    left: 0;
    /* Altura suficiente para el contenido y centrado vertical */
}
</style>